/* unplugin-vue-components disabled */import script from "./imgNav.vue?vue&type=script&setup=true&lang=js"
export * from "./imgNav.vue?vue&type=script&setup=true&lang=js"

import "./imgNav.vue?vue&type=style&index=0&id=008a53b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008a53b6"]])

export default __exports__